import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import axios from "../../api/axiosConfig";
import Loader from "../../components/Loader/Loader";
import {
  Box,
  Button,
  Stack,
  ToggleButtonGroup,
  ToggleButton,
} from "@mui/material";
import { WalletCards } from "./components/GetEquity/DataCards";
import FundWalletModal from "./components/GetEquity/FundWalletModal";
import Customers from "./components/GetEquity/Customers"; // update path if needed
import Tokens from "./components/GetEquity/Tokens"; // update path if needed
import Members from "./components/GetEquity/Members";

function GetEquity() {
  const [loading, setLoading] = useState(false);
  const [walletStats, setWalletStats] = useState({
    escrow: 0,
    balance: 0,
    totalVolume: 0,
    cash_usd_value: 0,
  });
  const [isFundModalOpen, setIsFundModalOpen] = useState(false);
  const [activeTab, setActiveTab] = useState("tokens");

  useEffect(() => {
    fetchWalletStats();
  }, []);

  const fetchWalletStats = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        "/marketplace/getequity/get-wallet-balance/",
      );

      setWalletStats(response.data?.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
      if (error.response?.data?.message)
        toast.error(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  // Button Handlers
  const handleRefreshWallet = async () => {
    try {
      setLoading(true);

      await axios.get("/marketplace/getequity/refresh-wallet-balance/");
    } catch (error) {
      console.error("Error fetching data: ", error);
      if (error.response?.data?.message)
        toast.error(error.response.data.message);
    } finally {
      fetchWalletStats();
    }
  };

  const handleFundWallet = () => {
    setIsFundModalOpen(true);
  };

  return (
    <div>
      {loading && (
        <div className="overlay">
          <Loader />
        </div>
      )}

      {/* stats */}
      <Box style={{ marginTop: "20px" }}>
        <div className="row equal-height">
          <div className="col-md-12 mb-4">
            <div className="card h-100">
              <div className="card-body">
                <WalletCards data={walletStats} />
              </div>
            </div>
          </div>
        </div>
      </Box>

      {/* Wallet Action Buttons */}
      <Box
        sx={{
          mb: 2,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Stack direction="row" spacing={2}>
          <Button
            variant="outlined"
            onClick={handleRefreshWallet}
            sx={{
              color: "black",
              borderColor: "black",
              "&:hover": {
                borderColor: "black",
                backgroundColor: "rgba(0,0,0,0.04)",
              },
            }}
          >
            Refresh Wallet
          </Button>

          <Button
            variant="contained"
            onClick={handleFundWallet}
            sx={{
              backgroundColor: "black",
              color: "white",
              "&:hover": {
                backgroundColor: "#222",
              },
            }}
          >
            Fund Wallet
          </Button>
        </Stack>
      </Box>

      {/* Dynamic View Section (Customers / Tokens) */}
      <Box style={{ marginTop: "20px" }}>
        <div className="row equal-height">
          <div className="col-md-12 mb-4">
            <div className="card h-100">
              <div className="card-body">
                {/* Slidable Switch */}
                <ToggleButtonGroup
                  value={activeTab}
                  exclusive
                  onChange={(e, newTab) => {
                    if (newTab !== null) setActiveTab(newTab);
                  }}
                  size="small"
                  sx={{
                    marginBottom: "20px",
                    bgcolor: "#f5f5f5",
                    p: "2px",
                    borderRadius: "4px",
                    "& .MuiToggleButton-root": {
                      border: "none",
                      borderRadius: "4px",
                      px: 3,
                      py: 0.75,
                      textTransform: "none",
                      fontWeight: 600,
                      color: "#666666",
                      "&.Mui-selected": {
                        bgcolor: "#000000",
                        color: "#ffffff",
                        "&:hover": {
                          bgcolor: "#1a1a1a",
                        },
                      },
                    },
                  }}
                >
                  <ToggleButton value="tokens">Tokens</ToggleButton>
                  <ToggleButton value="customers">Customers</ToggleButton>
                  <ToggleButton value="members">Members</ToggleButton>
                </ToggleButtonGroup>

                {/* Render Active Component */}
                {activeTab === "customers" ? (
                  <Customers />
                ) : (
                  <>{activeTab === "members" ? <Members /> : <Tokens />}</>
                )}
              </div>
            </div>
          </div>
        </div>
      </Box>

      {/* Fund Wallet Modal */}
      <FundWalletModal
        open={isFundModalOpen}
        onClose={() => setIsFundModalOpen(false)}
        onPaymentSuccess={handleRefreshWallet}
      />

      <ToastContainer />
    </div>
  );
}

export default GetEquity;
